import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107128Status: 'idle',
    startProcess107128Error: undefined as any,
    loadUserParamsProcess107128Status: 'idle',
    loadUserParamsProcess107128Error: undefined as any,

    process107128List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107128 = createAsyncThunk('process107128Slice/startProcess107128', async ({ process107128 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107128/`,
        prepareData(process107128),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107128Status } = getState().process107128Slice
        return startProcess107128Status !== 'pending'
    }
})

export const loadUserParamsProcess107128 = createAsyncThunk('process107128Slice/loadUserParamsProcess107128', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107128/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107128Status } = getState().process107128Slice
        return loadUserParamsProcess107128Status !== 'pending'
    }
})

const Process107128Slice = createSlice({
    name: 'process107128Slice',
    initialState,
    reducers: {
        resetstartProcess107128: (state) => {
            state.job = undefined
            state.startProcess107128Error = undefined
        },
        resetstartProcess107128Error: (state) => {
            state.startProcess107128Error = undefined
        },
        resetloadUserParamsProcess107128: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107128Error = undefined
        },
        resetloadUserParamsProcess107128Error: (state) => {
            state.loadUserParamsProcess107128Error = undefined
        },
        removeFromProcess107128ListById: (state, action) => {
            state.process107128List = state.process107128List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107128ListByIds: (state, action) => {
            state.process107128List = state.process107128List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107128List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107128Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107128List = []
            state.startProcess107128Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107128.pending, (state) => {
            state.startProcess107128Status = 'pending'
            state.startProcess107128Error = undefined
        })
        builder.addCase(startProcess107128.fulfilled, (state, action) => {
            state.startProcess107128Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107128.rejected, (state, action) => {
            state.startProcess107128Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107128Error = action.error.message
            } else {
                state.startProcess107128Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107128.pending, (state) => {
            state.loadUserParamsProcess107128Status = 'pending'
            state.loadUserParamsProcess107128Error = undefined
        })
        builder.addCase(loadUserParamsProcess107128.fulfilled, (state, action) => {
            state.loadUserParamsProcess107128Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107128.rejected, (state, action) => {
            state.loadUserParamsProcess107128Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107128Error = action.error.message
            } else {
                state.loadUserParamsProcess107128Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107128,
    resetstartProcess107128Error,
    resetloadUserParamsProcess107128,
    resetloadUserParamsProcess107128Error,
    removeFromProcess107128ListById,
    removeFromProcess107128ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107128Slice.actions
export default Process107128Slice.reducer
